@for (row of rows; track row) {
  <div [class.expanded]="row.expanded">
    <div class="expanded-list-item">
      <div class="caption">
        <i [class]="row.icon"></i>
        @if (captionIsLink) {
          <a (click)="onCaptionClicked($event, row)">{{ row.caption }}</a>
        }
        @if (!captionIsLink) {
          <span>{{ row.caption }}</span>
        }
      </div>
      @for (column of columns; track column; let i = $index) {
        <div class="amount-cell">
          <div class="d-inline-block d-sm-block column-header">{{ column.caption | translate }}</div>
          <div class="d-inline-block d-sm-block column-value">{{ row.getValue(column) }}</div>
        </div>
      }
      <button class="expand-btn" type="button" (click)="onClick(row)"><span></span></button>
    </div>
    <div class="expanded-content" [class.d-none]="!row.expanded">
      @if (row.expanded) {
        <app-list-view
          [columnDefinition]="row.columnDefinitions"
          [itemsSource]="row.items"
          [preferencesKey]="preferencesKey"
          (rowClick)="onExpandedContentRowClicked($event)"
        ></app-list-view>
      }
    </div>
  </div>
}
